// Product Page - PDP

import { getImages, getFeaturedImagesByColor } from '../components/images';
import { buildProduct, buildProducts } from '../components/buildProducts';
import { handleize } from '../helper/functions';
import { is_desktop_size } from '../helper/functions';
import { product_json } from '../helper/constants';
import 'slick-carousel';
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Sort the Size options
function sortSizeOptions(a, b) {
  let nameA = a.querySelector('input').value;
  let nameB = b.querySelector('input').value;
  let sizeOrder = ['OS', 'P-S', 'M-L', 'XXS', 'XS', 'S', 'M', 'L', 'XL', '1X', '2X', '3X'];
  if (sizeOrder.indexOf(nameA) < sizeOrder.indexOf(nameB)) {
    return -1;
  }
  if (sizeOrder.indexOf(nameA) > sizeOrder.indexOf(nameB)) {
    return 1;
  }
  return 0;
}

// Sort the Type options - Rolled or Flat
function sortTypeOptions(a, b) {
  let nameA = a.querySelector('input').value;
  let nameB = b.querySelector('input').value;
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}

// Sort Variant options
function filterSortVariantOptions(element, sortFunction) {
  let array = Array.from(element.children);
  let value_array = [];
  let node_array = [];
  let fragment = document.createDocumentFragment();

  for (let i = 0, limit = array.length; i < limit; i++) {
    let value = array[i].querySelector('input').value;
    if (value_array.includes(value) === false) {
      value_array.push(value);
      node_array.push(array[i]);
    }
  }

  node_array.sort(sortFunction);
  node_array[0].querySelector('input').checked = true;

  for (let i = 0, limit = node_array.length; i < limit; i++) {
    fragment.append(node_array[i]);
  }

  element.innerHTML = '';
  element.append(fragment);
}

// Product Scripts
document.addEventListener('DOMContentLoaded', function() {

  var size_options = document.querySelector('.js-size-options');
  var type_options = document.querySelector('.js-type-options');

  var is_gift_card = product_json && product_json.type && product_json.type.toLowerCase() === 'gift cards';

  let form = document.querySelector('#AddToCartForm');
  const cart = document.querySelector('cart-drawer');

  form.addEventListener('submit', (event) => {
    console.log('submit form');
    event.preventDefault();
    const id = form.querySelector('[name="id"]').value;
    const qty = form.querySelector('[name="quantity"]').value;
    let items = [
      {
        id: id,
        quantity: qty
      }
    ];
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        items,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', request)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        cart.trigger(cart);
        console.log(response);
        cart.renderContents(response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });

  console.log('added event listener');

  // #GLOBALEGIFTCARD temporary
  // Change Gift Card prices on variant type selectors to be locale currency
  var international_gift_card = false;
  if (is_gift_card && window.Shopify.routes.root.length > 1) {
    international_gift_card = true;
    let locale_prices = document.querySelector('.js-giftcard-prices').children;
    let price_buttons = type_options.children;
    for (let i = 0, limit = price_buttons.length; i < limit; i++) {
      price_buttons[i].querySelector('label').textContent = locale_prices[i].textContent;
    }
  }

  if (size_options) {
    filterSortVariantOptions(size_options, sortSizeOptions);
    size_options.classList.remove('pdp-variant-options--hidden');
  }
  if (type_options) {
    if (!is_gift_card) {
      filterSortVariantOptions(type_options, sortTypeOptions);
    }
    type_options.classList.remove('pdp-variant-options--hidden');
  }

  var radios = document.querySelectorAll('[data-option-radio]');
  // var selects = document.querySelectorAll("[data-option-select]");
  var main = document.querySelector('[data-option-main]');

  const all_selectors = Array.from(document.querySelectorAll('.sizing-item input'));
  const size_selectors = document.querySelectorAll('.sizing-item--size input');
  const type_selectors = document.querySelectorAll('.sizing-item--type input');

  var selected = [];

  var add_to_cart_container = document.querySelector('.js-add-to-cart-container');
  var add_to_cart_button = document.querySelector('.js-add-to-cart');
  var sold_out = document.querySelector('.js-sold-out');

  const out_of_stock_elements = document.querySelectorAll('.js-out-of-stock');

  var variants_json = JSON.parse(document.querySelector('.js-variants-json').innerHTML);

  // console.log('variants_json',variants_json);

  const color_items = document.querySelectorAll('.color-item');
  var color_items_arr = Array.prototype.slice.call(color_items);

  // NOSTO AB TEST
  // Original sort color swatch sort code
  // color_items_arr.sort(function(a, b){
  //   if(a.dataset.name < b.dataset.name) { return -1; }
  //   if(a.dataset.name > b.dataset.name) { return 1; }
  //   return 0;
  // })

  // let j = 0

  // for (const color_item of color_items_arr) {
  //   color_item.style.order = j
  //   j++
  // }
  // END NOSTO AB TEST

  // let options_json = document.querySelector('.js-options-json') ? JSON.parse(document.querySelector(".js-options-json").innerHTML) : null;

  // NOSTO AB TEST
  // var handles_nosto_ab = {};
  // handles_nosto_ab[product_json.handle] = [];
  // product_json.variants.forEach((variant) => {
  //   handles_nosto_ab[product_json.handle].push(variant.option1);
  // });
  // END NOSTO AB TEST

  // Master Products
  // Concatenate the images and variants arrays from the master product JSON into the product JSON
  if (document.querySelector('.js-master-product-json')) {
    let prod_arr = document.querySelectorAll('.js-master-product-json');
    for (let i = 0, limit = prod_arr.length; i < limit; i++) {
      let product_master_json = JSON.parse(prod_arr[i].innerHTML);
      product_json.images = product_json.images.concat(product_master_json.images);
      product_json.variants = product_json.variants.concat(product_master_json.variants);

      // NOSTO AB TEST
      // handles_nosto_ab[product_master_json.handle] = [];
      // product_master_json.variants.forEach((variant) => {
      //   handles_nosto_ab[product_master_json.handle].push(variant.option1);
      // });
      // END NOSTO AB TEST
    }
  }

  const in_stock_variants = {};
  const out_stock_variants = {};

  // key for the site props index
  for (let [key, value] of Object.entries(variants_json)) {
    if (value.available === false) {
      out_stock_variants[key] = value;
    } else {
      in_stock_variants[key] = value;
    }
  }

  // Check if the product is sold out for each color and add it to the product_json
  if (color_items.length > 0) {
    let color_option = product_json.options.find((e) => e.toLowerCase() === 'color');
    let color_index;
    if (color_option) {
      color_index = 'option' + (product_json.options.indexOf(color_option) + 1);
    }
    soldOutColors(product_json, color_index);
  }

  const model_info_jsons = document.querySelectorAll('.js-images-json');
  var model_info = {};
  model_info_jsons.forEach((e) => {
    let json = JSON.parse(e.innerHTML);
    for (let key in json) {
      model_info[key] = json[key];
    }
  });
  // console.log(model_info);

  // Check the variants of a product to see if any are in stock
  function soldOutColors(product, color_index) {
    var variant_stock = [];

    for (let i = 0, limit = product.variants.length; i < limit; i++) {
      let variant = product.variants[i];

      if (i === limit - 1) {
        variant_stock.push(variant.available);

        if (variant_stock.includes(true)) {
          // in_stock_colors.push(variant);
          document.querySelector(`.color-item[data-variant="${variant[color_index]}"`).classList.remove('sold-out-color');
        } else {
          document.querySelector(`.color-item[data-variant="${variant[color_index]}"`).classList.add('sold-out-color');
        }

        break;
      }

      if (product.variants[i][color_index] === product.variants[i + 1][color_index]) {
        variant_stock.push(variant.available);
      } else {
        variant_stock.push(variant.available);

        if (variant_stock.includes(true)) {
          // in_stock_colors.push(variant[color_index]);
          document.querySelector(`.color-item[data-variant="${variant[color_index]}"`).classList.remove('sold-out-color');
        } else {
          document.querySelector(`.color-item[data-variant="${variant[color_index]}"`).classList.add('sold-out-color');
        }

        variant_stock = [];
      }
    }
  }

  function getSelectedRadios() {
    selected = [];

    // set the selected variant
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].checked) {
        selected.push(radios[j].value);
      }
    }
    return selected;
  }

  function doesVariantExist(selected_variant) {
    // Check if variant exists
    let variant_exists = true;

    if (!selected_variant) {
      variant_exists = false;
    }

    return variant_exists;
  }

  // Check the availability of each color swatch and update the classes accordingly
  function colorSwatchAvailability(option_selection) {
    for (let i = 0, limit = color_items.length; i < limit; i++) {
      let color = color_items[i].dataset.variant;
      let selected_swatch;
      let color_var = color + ' / ' + option_selection;

      if (color_items[i].querySelector('input')) {
        selected_swatch = color_items[i].querySelector('input').checked;
      }

      if ((variants_json[color_var] && variants_json[color_var].available) || selected_swatch) {
        color_items[i].classList.remove('sold-out-size');
      } else {
        color_items[i].classList.add('sold-out-size');
      }
    }
  }

  // Check if the selected variant exists and if it does, update the availability of the color swatches
  function oneOptionVariant(selectors, selected_variant) {
    let variant_exists = doesVariantExist(selected_variant);

    if (variant_exists) {
      colorSwatchAvailability(selected[1]);
    }

    for (let i = 0, limit = selectors.length; i < limit; i++) {
      let variant_key = selected[0] + ' / ' + selectors[i].value;
      if (variants_json[variant_key]) {
        // Show selectors for related variants that do exist
        selectors[i].parentElement.classList.remove('hidden');

        // If selected variant didnt exist select first available option
        if (variant_exists === false && variants_json[variant_key].available) {
          selectors[i].checked = true;
          selected_variant = variants_json[variant_key];
          variant_exists = true;
          colorSwatchAvailability(selectors[i].dataset.value);
        }

        if (out_stock_variants[variant_key]) {
          document
            .querySelector('[data-option="' + handleize(selectors[i].value) + '"]')
            .classList.add('sold-out-option');
        } else if (in_stock_variants[variant_key]) {
          document
            .querySelector('[data-option="' + handleize(selectors[i].value) + '"]')
            .classList.remove('sold-out-option');
        }
      } else {
        // Hide selectors for related variants that dont exist
        selectors[i].parentElement.classList.add('hidden');
      }
    }

    return selected_variant;
  }

  function twoOptionVariant(selectors_1, selectors_2, selected, selected_variant) {
    let variant_exists = doesVariantExist(selected_variant);
    let current_selected = selected;
    // Find which variants exist for selected color given options 2 and 3 for all colors
    let actual_variants = {};

    if (variant_exists) {
      let option_selection = selected[1] + ' / ' + selected[2];
      colorSwatchAvailability(option_selection);
    }

    for (let i = 0, limit = selectors_1.length; i < limit; i++) {
      for (let j = 0, limit = selectors_2.length; j < limit; j++) {
        let variant_key = current_selected[0] + ' / ' + selectors_1[i].value + ' / ' + selectors_2[j].value;
        let variant_data = variants_json[variant_key];

        if (variant_data) {
          actual_variants[variant_key] = variant_data;

          // If selected variant didnt exist select first available option
          if (variant_exists === false && variant_data.available) {
            selectors_1[i].checked = true;
            selectors_2[j].checked = true;
            selected_variant = variant_data;
            variant_exists = true;
            current_selected = getSelectedRadios();
            let option_selection = selectors_1[i].dataset.value + ' / ' + selectors_2[j].dataset.value;
            colorSwatchAvailability(option_selection);
          }
        }
      }
    }

    let varOpt1 = [];
    let varOpt2 = [];

    // Find which options exist for selected color
    for (let [key, val] of Object.entries(actual_variants)) {
      let keys = key.split(' / ');

      // If selected variant doesn't exist and is totally sold out
      if (variant_exists === false) {
        let selector_1 = document.querySelector(`.sizing-item input[data-value="${keys[1]}"]`);
        let selector_2 = document.querySelector(`.sizing-item input[data-value="${keys[2]}"]`);
        selector_1.checked = true;
        selector_2.checked = true;
        selected_variant = val;
        variant_exists = true;
        current_selected = getSelectedRadios();
        let option_selection = selector_1.dataset.value + ' / ' + selector_2.dataset.value;
        colorSwatchAvailability(option_selection);
      }

      for (let i = 0, limit = selectors_1.length; i < limit; i++) {
        if (keys.includes(selectors_1[i].value) && !varOpt1.includes(selectors_1[i])) {
          varOpt1.push(selectors_1[i]);
        }
      }

      for (let i = 0, limit = selectors_2.length; i < limit; i++) {
        if (keys.includes(selectors_2[i].value) && !varOpt2.includes(selectors_2[i])) {
          varOpt2.push(selectors_2[i]);
        }
      }
    }

    // For option 1 hide buttons for variants that dont exist
    for (let i = 0, limit = selectors_1.length; i < limit; i++) {
      if (varOpt1.includes(selectors_1[i])) {
        selectors_1[i].parentElement.classList.remove('hidden');
      } else {
        selectors_1[i].parentElement.classList.add('hidden');
      }
    }

    // For option 2 hide buttons for variants that dont exist
    for (let i = 0, limit = selectors_2.length; i < limit; i++) {
      if (varOpt2.includes(selectors_2[i])) {
        selectors_2[i].parentElement.classList.remove('hidden');
      } else {
        selectors_2[i].parentElement.classList.add('hidden');
      }
    }

    // For all option 1 buttons if all option 2 sold out then mark button sold out
    for (let i = 0, limit = varOpt1.length; i < limit; i++) {
      let sold_out_1 = [];

      for (let j = 0, limit = varOpt2.length; j < limit; j++) {
        let variant_key = current_selected[0] + ' / ' + varOpt1[i].value + ' / ' + varOpt2[j].value;

        if (out_stock_variants[variant_key]) {
          sold_out_1.push(variant_key);
        }
      }

      if (sold_out_1.length === varOpt2.length) {
        varOpt1[i].nextElementSibling.classList.add('sold-out-option');
      } else {
        varOpt1[i].nextElementSibling.classList.remove('sold-out-option');
      }
    }

    // For selected mark option 2 sold out
    for (let i = 0, limit = varOpt2.length; i < limit; i++) {
      let variant_key = current_selected[0] + ' / ' + current_selected[1] + ' / ' + varOpt2[i].value;

      if (out_stock_variants[variant_key]) {
        varOpt2[i].nextElementSibling.classList.add('sold-out-option');
      } else if (in_stock_variants[variant_key]) {
        varOpt2[i].nextElementSibling.classList.remove('sold-out-option');
      }
    }

    return selected_variant;
  }

  // Take in the selected radio buttons and return the variant that matches
  function updateVariantOptions(size_selectors, type_selectors) {
    let selected = getSelectedRadios();
    let selected_variant = variants_json[selected.join(' / ')];

    // Both size and type
    if (size_selectors.length > 0 && type_selectors.length > 0) {
      // Size before type
      if (all_selectors.indexOf(size_selectors[0]) < all_selectors.indexOf(type_selectors[0])) {
        selected_variant = twoOptionVariant(size_selectors, type_selectors, selected, selected_variant);
        // Type before size
      } else {
        selected_variant = twoOptionVariant(type_selectors, size_selectors, selected, selected_variant);
      }
      // Size
    } else if (size_selectors.length > 0) {
      selected_variant = oneOptionVariant(size_selectors, selected_variant);
      // Type
    } else if (type_selectors.length > 0) {
      selected_variant = oneOptionVariant(type_selectors, selected_variant);
    }

    // NOSTO AB TEST
    // let current_path = window.location.pathname;
    // let current_handle = current_path.substring(current_path.indexOf(product_json.handle));
    // let new_handle;

    // for (const product_handle in handles_nosto_ab) {
    //   if (handles_nosto_ab[product_handle].includes(selected_variant.color)) {
    //     new_handle = product_handle;
    //     break;
    //   }
    // }

    // let reload_page = true;
    // if (current_handle.includes(new_handle)) {
    //   reload_page = false;
    // }

    // if (reload_page) {
    //   let color_path = '/products/' + new_handle + '/' + handleize(selected_variant.color);
    //   window.location.href = window.location.protocol + "//" + window.location.host + color_path;
    //   throw new Error('This is not an error. This is just to abort javascript');
    // }
    // END NOSTO AB TEST

    return selected_variant;
  }

  const page_title = document.title;
  const meta_description = document.querySelector('meta[name="description"]');

  // get the current variant
  let path = window.location.pathname;

  let path_var_pos = path.indexOf(product_json.handle) + product_json.handle.length + 1;
  let path_var = path.substring(path_var_pos);

  let current_variant = '';

  // if an option is defined in the pathname
  if (path_var.length !== 0) {
    current_variant = product_json.variants.find((e) => handleize(e.option1).indexOf(path_var) !== -1);
  }

  let selected_on_land =
    current_variant !== '' ? variants_json[current_variant.title] : variants_json[main.options[main.selectedIndex].text];

  // let selected_on_land = variants_json[main.options[main.selectedIndex].text]

  document.querySelector(`[data-value="${selected_on_land.color}"]`).checked = true;

  if (color_items.length > 0) {
    selected_on_land = updateVariantOptions(size_selectors, type_selectors);
  }

  updateSelection(selected_on_land);

  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener('change', function () {
      let selected_variant;

      if (color_items.length > 0) {
        selected_variant = updateVariantOptions(size_selectors, type_selectors);
      } else {
        selected = [];
        // set the selected variant
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].checked) {
            selected.push(radios[j].value);
          }
        }
        selected_variant = variants_json[selected.join(' / ')];
      }

      // disable any options without quantity
      // This might be removable code below not sure if it does anything
      // if (options_json) {
      //   let options = options_json[selected[0]]

      //   for (let [key, value] of Object.entries(options)) {
      //     if (value == 'false') {
      //       document.querySelector('[data-value=' + key + ']').disabled = true;
      //     } else {
      //       document.querySelector('[data-value=' + key + ']').disabled = false;
      //     }
      //   }
      // }

      updateSelection(selected_variant);
    });
  }

  // Update the product selection based on the selected variant
  function updateSelection(selected_variant) {
    if (selected_variant.color && Shopify.designMode === undefined) {
      // Update browser URL
      let product_path = 'products/' + product_json.handle;

      if (product_path.charAt(product_path.length - 1) !== '/') {
        product_path = product_path + '/';
      }

      let color_path = product_path + handleize(selected_variant.color);

      let history_state = history.state;
      history.replaceState(history_state, '', window.Shopify.routes.root + color_path);

      // Update canonical URL
      let canonical_url = location.protocol + '//' + location.host + '/' + color_path;
      document.querySelector('link[rel="canonical"]').setAttribute('href', canonical_url);

      // Update title
      let title_pieces = page_title.split(' | Hanky Panky');
      let color_title = selected_variant.color
        .toLowerCase()
        .replace(/\w+/g, (word) => word.replace(/^\w/, (char) => char.toUpperCase()));
      let new_page_title = `${title_pieces[0]} in ${color_title} | Hanky Panky`;
      if (document.title !== new_page_title) {
        document.title = new_page_title;
      }

      // Update description
      if (is_gift_card) {
        meta_description.setAttribute(
          'content',
          `Shop the ${product_json.title} at the official Hanky Panky site. Rewards members enjoy free US shipping on all orders.`
        );
      } else {
        meta_description.setAttribute(
          'content',
          `Shop the ${product_json.title} in ${color_title} at the official Hanky Panky site. Rewards members enjoy free US shipping on all orders.`
        );
      }
    }

    // change main value
    main.value = selected_variant.id;

    // change images
    changeVariant(selected_variant.id);

    // update option name
    if (document.querySelector('.js-inventory[data-type="Size"]')) {
      if (selected_variant.inventory > 0) {
        document.querySelector('.js-inventory[data-type="Size"]').innerHTML = `Only ${selected_variant.inventory} left!`;
      } else {
        document.querySelector('.js-inventory[data-type="Size"]').innerHTML = '';
      }
    }

    // look for panky points element created by theme setting double_panky_points
    // let pankyPoints = parseFloat(selected_variant.price.substring(1));

    // if (document.querySelector('.js-double-panky-points')) {
    //   pankyPoints = Math.floor(pankyPoints * 2);
    // } else if (document.querySelector('.js-triple-panky-points')) {
    //   pankyPoints = Math.floor(pankyPoints * 3);
    // } else {
    //   pankyPoints = Math.floor(pankyPoints);
    // }

    // document.querySelector('.js-points').innerHTML = pankyPoints;
    // document.querySelector('.js-points').innerHTML = selected_variant.price.substring(1)

    // update pricing
    if (document.querySelector('.js-variant-price')) {
      if (window.Shopify.routes.root.length > 1) {
        jQuery('.js-variant-price').html(selected_variant.price_with_currency);
      } else {
        jQuery('.js-variant-price').html(selected_variant.price);
      }
      // document.querySelector(".js-variant-price").innerHTML =
      //   selected_variant.price;
    }

    let compare_at_price = selected_variant.compare_at_price;

    if (compare_at_price != '$0' && compare_at_price != '') {
      // document.querySelector(".js-variant-compare-price").style.display = 'block'
      // document.querySelector(".js-variant-compare-price").innerHTML = compare_at_price;

      jQuery('.js-variant-compare-price').show();

      if (window.Shopify.routes.root.length > 1) {
        jQuery('.js-variant-compare-price').html(selected_variant.compare_at_price_with_currency);
      } else {
        jQuery('.js-variant-compare-price').html(compare_at_price);
      }

      // document.querySelector(".js-variant-price").classList.add('text-orange')
      jQuery('.js-variant-price').addClass('text-orange');
    } else {
      jQuery('.js-variant-compare-price').hide();
      jQuery('.js-variant-compare-price').html('');
      // document.querySelector(".js-variant-compare-price").style.display = 'none'
      // document.querySelector(".js-variant-compare-price").innerHTML = ''
      // document.querySelector(".js-variant-price").classList.remove('text-orange')
      jQuery('.js-variant-price').removeClass('text-orange');
    }

    // if not available, let them know
    // if (selected_variant.available == "true") {
    //   add_to_cart_container.style.display = "block";
    //   sold_out.style.display = "none";
    // } else {
    //   add_to_cart_container.style.display = "none";
    //   sold_out.style.display = "block";
    // }

    for (const out_of_stock of out_of_stock_elements) {
      out_of_stock.style.display = 'none';

      if (
        selected_variant.id.toString() == out_of_stock.dataset.variantId.toString() &&
        selected_variant.available.toString() == 'false'
      ) {
        document.querySelector('.js-biscustom-select').value = out_of_stock.dataset.variantId;
        out_of_stock.style.display = 'block';
      }
    }

    if (selected_variant.available.toString() == 'false') {
      sold_out.style.display = 'block';
    } else {
      sold_out.style.display = 'none';
    }
  }

  jQuery(document).ready(() => {
    changeVariant();
  });

  function changeVariant() {
    let slider = document.querySelector('.js-images');
    let lightbox = document.querySelector('.js-product-lightbox-images');

    unsetSlider(slider);
    unsetSlider(lightbox);

    // let product = JSON.parse(document.querySelector('.js-product-json').innerHTML);
    let product = product_json;

    let featured_images = getFeaturedImagesByColor(product);

    // console.log('changeVariant featured_images',featured_images);

    let has_featured_images = featured_images.length != 0 ? true : false;
    let images = has_featured_images ? featured_images : getImages(product);

    // console.log('changeVariant images',images);

    let id = variants_json[main.options[main.selectedIndex].text].color;

    if (international_gift_card) {
      document.querySelector('.js-selected-color').innerHTML = variants_json[main.options[main.selectedIndex].text].price;
    } else {
      document.querySelector('.js-selected-color').innerHTML = id;
    }

    updateThumbnails(images, id, has_featured_images);
    updateMainImages(images, id, has_featured_images);
    updateLightboxImages(images, id, has_featured_images);

    addArrows();

    let next = document.querySelector('.js-next');
    let prev = document.querySelector('.js-prev');

    let lightbox_next = document.querySelector('.js-lightbox-next');
    let lightbox_prev = document.querySelector('.js-lightbox-prev');

    setSlider(slider, next, prev);
    setSlider(lightbox, lightbox_next, lightbox_prev);

    setNav();

    revealImageBlock();

    if (is_desktop_size) {
      imageZoomPan();
    }
  }

  // Update the lightbox images based on the selected variant
  function updateLightboxImages(images, id, has_featured_images) {
    let main_images = has_featured_images ? images[id] : images;
    let main_images_block = '';

    if (main_images) {
      let variant_title = toTitleCase(variants_json[main.options[main.selectedIndex].text].color),
        main_images_array = Array.from(main_images);
      let variant_color = variants_json[main.options[main.selectedIndex].text].color;

      main_images_array.forEach((main_image, index) => {
        let srcset = buildSrcset(main_image);

        let model_info_text = '';
        if (model_info[variant_color]) {
          if (model_info[variant_color][index + 1]) {
            model_info_text = `<p class="product-image-model-info">${model_info[variant_color][index + 1]}</p>`;
          }
        }

        let main_image_block = `
          <div class='js-product-lightbox-slide product-lightbox__slide'>
            <img class='block z-20 absolute inset-0 w-full h-full object-contain object-top' src='${main_image}' srcset='${srcset}' alt='${
              product_json.title
            } in ${variant_title} - Hanky Panky - View ${index + 1}' />
            ${model_info_text}
          </div>
        `;
        main_images_block += main_image_block;
      });

      let total_number = document.querySelector('.js-product-lightbox-total');
      total_number.textContent = main_images_array.length;
    }

    document.querySelector('.js-product-lightbox-images').innerHTML = main_images_block;

    // let slides = document.querySelectorAll('.js-product-lightbox .js-product-lightbox-slide');

    // slides.forEach((element) => {
    //   element.addEventListener('click', toggleLightbox);
    // });
  }

  // Toggle the lightbox for the product page
  function toggleLightbox() {
    var product_lightbox = document.querySelector('.js-product-lightbox');
    var product_lightbox_slick = document.querySelector('.js-product-lightbox-images');
    let current_number = document.querySelector('.js-product-lightbox-current');

    $(product_lightbox_slick).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      // $(lightbox).slick('slickGoTo', currentSlide);
      // console.log(nextSlide);
      current_number.textContent = nextSlide + 1;
    });

    if (product_lightbox.classList.contains('invisible')) {
      window.requestAnimationFrame(() => {
        document.body.classList.add('size-chart-open');
        product_lightbox.classList.add('opacity-0');
        product_lightbox.classList.remove('invisible');

        window.requestAnimationFrame(() => {
          let current_slide = $('.js-images').slick('slickCurrentSlide');
          $(product_lightbox_slick).slick('slickGoTo', current_slide, true);
          product_lightbox.classList.remove('opacity-0');
        });
      });
    } else {
      let current_slide = $(product_lightbox_slick).slick('slickCurrentSlide');
      $('.js-images').slick('slickGoTo', current_slide, true);
      product_lightbox.addEventListener(
        'transitionend',
        () => {
          product_lightbox.classList.add('invisible');
        },
        { once: true }
      );

      document.body.classList.remove('size-chart-open');
      window.requestAnimationFrame(() => {
        product_lightbox.classList.add('opacity-0');
      });
    }
  }

  if (document.querySelector('.js-product-lightbox')) {
    const close_product_lightbox = document.querySelector('.js-product-lightbox-close');
    const product_lightbox = document.querySelector('.js-product-lightbox');
    close_product_lightbox.addEventListener('click', toggleLightbox);
  }

  // Image Thumbnail Nav
  function setNav() {
    jQuery('.js-thumbnail').click(function () {
      let slideIndex = jQuery(this).index();
      jQuery('.js-images').slick('slickGoTo', parseInt(slideIndex));
    });
  }

  function addArrows() {
    let arrows = `
      <button class='js-prev transition duration-500 p-2 md:p-8 outline-none z-20 absolute left-0 top-1/2 transform -translate-y-1/2' style='outline:none'>
        <svg width="15px" height="27px" viewBox="0 0 15 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-48.000000, -496.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(8.545455, 15.128788) rotate(-270.000000) translate(-8.545455, -15.128788) translate(-4.454545, 7.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 12.245345 0.973568282 0.569550931 0 1.53778751 12.7136564 14.1818182 26 0.968236583"></polygon></g></g></g></g></g></svg>
      </button>
      <button class='js-next transition duration-500 p-2 md:p-8 outline-none z-20 absolute right-0 top-1/2 transform -translate-y-1/2' style='outline:none'>
      <svg width="14px" height="27px" viewBox="0 0 14 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-1378.000000, -494.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(1339.454545, 13.545455) rotate(-90.000000) translate(-1339.454545, -13.545455) translate(1326.454545, 6.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 11.3033954 0.973568282 0.525739321 0 1.41949617 12.7136564 13.0909091 26 0.893756846"></polygon></g></g></g></g></g></svg>
      </button>
      `;

    document.querySelector('.js-arrows').innerHTML = arrows;
  }

  function unsetSlider(el) {
    if (jQuery(el).hasClass('slick-initialized')) {
      jQuery(el).slick('unslick');
    }
  }

  function setSlider(el, next, prev) {
    jQuery(el).slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      nextArrow: jQuery(next),
      prevArrow: jQuery(prev)
    });
  }

  function hideImageBlock() {
    document.querySelector('.js-block').style.opacity = 0;
  }

  function revealImageBlock() {
    document.querySelector('.js-block').style.opacity = 1;
  }

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  // Update the image thumbnails using the images object, the product ID, and product featured images
  function updateThumbnails(images, id, has_featured_images) {
    let thumbnail_images = has_featured_images ? images[id] : images;
    let thumbnail_images_block = '';

    if (thumbnail_images) {
      // EUCUSTOM Refactored loop to forEach and added alt text
      let variant_title = toTitleCase(variants_json[main.options[main.selectedIndex].text].color),
        thumbnail_images_array = Array.from(thumbnail_images);

      let imgFileType = '.jpg';

      thumbnail_images_array.forEach((thumbnail_image, index) => {
        if (thumbnail_image.includes('.png')) {
          imgFileType = '.png';
        }

        let thumbImg = thumbnail_image.replace('https:', ''),
          thumbSrc = thumbImg.replace(imgFileType, `_x300${imgFileType}`);

        let thumbnail_image_block = `
          <div class='border border-beige mb-4 js-thumbnail'>
            <div class='cursor-pointer w-full pt-150 relative'>
              <img src='${thumbSrc}' data-src='${thumbImg.split('?v=')[0]}' alt='${
                product_json.title
              } in ${variant_title} - Hanky Panky - Thumbnail View ${
                index + 1
              }' class='w-full h-full inset-0 absolute object-cover'>
            </div>
          </div>
        `;
        thumbnail_images_block += thumbnail_image_block;
      });
    }

    document.querySelector('.js-thumbnails').innerHTML = thumbnail_images_block;

    setTimeout(function () {
      var img = document.querySelector('.js-variants option:checked').dataset.variantImage;
      document.querySelector('.js-thumbnail img[data-src="' + img + '"]').click();
    }, 50);
  }

  // Update the main image block using the images object, the product ID, and product featured images
  function updateMainImages(images, id, has_featured_images) {
    let main_images = has_featured_images ? images[id] : images;
    let main_images_block = '';

    if (main_images) {
      // EUCUSTOM Refactored loop to forEach and added alt text
      let variant_title = toTitleCase(variants_json[main.options[main.selectedIndex].text].color),
        main_images_array = Array.from(main_images);

      let variant_color = variants_json[main.options[main.selectedIndex].text].color;

      main_images_array.forEach((main_image, index) => {
        // original
        //
        // let main_image_block = `
        //   <div class='w-full pt-150 h-0 relative'>
        //     <img class='block z-20 absolute inset-0 w-full h-full object-cover' src='${main_image}' alt='${product_json.title} in ${variant_title} - Hanky Panky - View ${index + 1}' />
        //   </div>
        // `

        let model_info_text = '';
        if (model_info[variant_color]) {
          if (model_info[variant_color][index + 1]) {
            model_info_text = `<p class="product-image-model-info">${model_info[variant_color][index + 1]}</p>`;
          }
        }

        let srcset = buildSrcset(main_image);

        let main_image_block = `
          <div class='js-zoom-pan zoom-pan w-full pt-150 h-0 relative border-beige border-r lg:border-r-0'>
            <img class='block z-20 absolute inset-0 w-full h-full object-cover' src='${main_image}' srcset='${srcset}' alt='${
              product_json.title
            } in ${variant_title} - Hanky Panky - View ${index + 1}' />
            ${model_info_text}
          </div>
        `;
        main_images_block += main_image_block;
      });

      // for (let main_image of main_images) {
      //   let main_image_block = `
      //     <div class='w-full pt-150 h-0 relative'>
      //       <img class='block z-20 absolute inset-0 w-full h-full object-cover' src='${main_image}' alt='' />
      //     </div>
      //   `
      //   main_images_block += main_image_block
      // }
    }

    document.querySelector('.js-images').innerHTML = main_images_block;

    let slides = document.querySelectorAll('.js-images .js-zoom-pan');

    slides.forEach((element) => {
      element.addEventListener('click', toggleLightbox);
    });
  }

  // Zoom and pan on product image
  function imageZoomPan() {
    let active_slide = document.querySelector('.js-images .slick-active .js-zoom-pan');
    let active_image = active_slide.querySelector('img');

    // determine level of zoom so image is roughly 900px wide when zoomed in
    // 900px was chosen to support default 1300px wide product images at passable resolution
    let coords = document.querySelector('.js-images .slick-list').getBoundingClientRect();
    let scale = 900 / coords.width;
    let offset = window.pageYOffset;

    /*
    active_slide.addEventListener('mouseover', () => {
      active_image.style.transform = `scale(${scale})`;
    });
    */
    active_slide.addEventListener('mouseout', () => {
      active_image.style.transform = 'scale(1)';
      // active_image.style.cursor = '';
    });
    active_slide.addEventListener('mousemove', (e) => {
      active_image.style.transform = `scale(${scale})`;
      // active_image.style.cursor = 'zoom-in';
      let maths = `${((e.pageX - coords.left) / coords.width) * 100}% ${
        ((e.pageY - coords.top - offset) / coords.height) * 100
      }%`;
      active_image.style.transformOrigin = maths;
    });
  }
  if (is_desktop_size) {
    $('.js-images').on('afterChange', (e, s, d) => {
      imageZoomPan();
    });
  }

  // helpers
  function buildSrcset(image) {
    let srcsetSuffix = [1300, 1200, 1100, 1000, 900, 800, 700],
      imgFileType = '.jpg',
      srcset = '';

    if (image.includes('.png')) {
      imgFileType = '.png';
    }

    let prodImg = image.replace('https:', '');

    for (let i = 0, limit = srcsetSuffix.length; i < limit; i++) {
      srcset += prodImg.replace(`${imgFileType}`, `_${srcsetSuffix[i]}x${imgFileType}`);
      srcset += ` ${srcsetSuffix[i]}w,`;
    }

    return srcset;
  }

  const decrease = document.querySelector('.js-counter-remove');
  const increase = document.querySelector('.js-counter-add');
  const quantity = document.querySelector('.js-counter-quantity');

  const min = parseInt(quantity.attributes.min.value);
  const max = parseInt(quantity.attributes.max.value);

  let count = parseInt(quantity.value);

  const set = (i) => {
    count = Math.max(min, Math.min(i, max || 10000));
    quantity.value = count;
  };

  decrease.addEventListener('click', (e) => {
    e.preventDefault();
    set(--count);
  });

  increase.addEventListener('click', (e) => {
    e.preventDefault();
    set(++count);
  });

  (async () => {
    const pairs_with_containers = document.querySelectorAll('.js-pairs-with');

    for (const pairs_with_container of pairs_with_containers) {
      await buildProducts(pairs_with_container);
    }

    const container = document.querySelector('.js-collection');
    if (container) {
      await buildProducts(container);
    }

    const recommended = document.querySelector('.js-recommended');

    if (recommended) {
      const id = recommended.dataset.id;

      fetch(`/recommendations/products.json?product_id=${id}&limit=4`)
        .then((response) => response.json())
        .then(({ products }) => {
          if (products.length > 0) {
            for (const product of products) {
              const el = document.createElement('div');
              el.dataset.handle = product.handle;
              recommended.appendChild(el);
              buildProduct(el);
            }
          }
        });
    }
  })();

  function getCountdown() {
    const el = jQuery('.js-countdown');

    if (document.querySelector('.js-countdown')) {
      let countdown_date = el.data().date;
      let countdown_date_timestamp = new Date(countdown_date);
      let current_date_timestamp = new Date();

      let diff = diff_hours(countdown_date_timestamp, current_date_timestamp);

      if (diff <= 0) {
        // document.querySelector('.js-countdown-container').style.display = 'none'
        jQuery('.js-countdown-container').hide();
      }

      el.html(diff);
    }
  }

  function diff_hours(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;

    return Math.round(diff);
  }

  getCountdown();

  // Custom Back In Stock App Form
  if (out_of_stock_elements.length > 0) {
    for (const out_of_stock of out_of_stock_elements) {
      out_of_stock.addEventListener("click", BISCustomFormShow);
    }
    function BISCustomFormShow(e) {
      let modal = document.querySelector(".biscustom-modal-outer");
      window.requestAnimationFrame(() => {
        modal.classList.remove("biscustom-modal-outer--hidden");
        window.requestAnimationFrame(() => {
          modal.classList.add("biscustom-modal-outer--fade-in");
        });
      });
    }
    function BISCustomFormHide(e) {
      let modal = document.querySelector(".biscustom-modal-outer");
      let bis_message = document.querySelector(".js-biscustom-message");
      if (modal.classList.contains("biscustom-modal-outer--fade-in")) {
        modal.addEventListener(
          "transitionend",
          () => {
            modal.classList.add("biscustom-modal-outer--hidden");
            bis_message.classList.remove("text-orange");
            bis_message.classList.remove("text-light-blue");
            bis_message.textContent =
              "We'll notify you when this product is in stock. We don't share your address with anybody else.";
          },
          { once: true }
        );
        modal.classList.remove("biscustom-modal-outer--fade-in");
      }
    }
    document
      .querySelector(".js-biscustom-bg-close")
      .addEventListener("click", BISCustomFormHide);
    document
      .querySelector(".js-biscustom-close")
      .addEventListener("click", BISCustomFormHide);
    function BISCustomFormSubmit(e) {
      e.preventDefault();
      let bis_select = document.querySelector(".js-biscustom-select"),
        bis_selected = bis_select[bis_select.selectedIndex],
        bis_product_id = parseInt(bis_selected.dataset.product),
        bis_variant_id = parseInt(bis_selected.dataset.variant),
        bis_newsletter = document.querySelector(
          ".js-biscustom-newsletter"
        ).checked,
        bis_email = document.querySelector(".js-biscustom-email").value,
        bis_message = document.querySelector(".js-biscustom-message");

      function BISCustomResponse(response) {
        if (response.status == "OK") {
          console.log("OK", response);
          bis_message.classList.add("text-light-blue");
          bis_message.textContent =
            "Thanks! We'll let you know if this is restocked.";
          setTimeout(BISCustomFormHide, 3000);
        } else {
          console.log("Error", response);
          bis_message.classList.add("text-orange");
          let error_message = "";
          for (let error in response.errors) {
            console.log(response.errors[error]);
            response.errors[error].forEach((e) => {
              error_message += e + " ";
            });
          }
          bis_message.textContent = error_message;
        }
      }

      if (bis_newsletter) {
        BIS.create(bis_email, bis_variant_id, bis_product_id, {
          accepts_marketing: true,
        }).then(BISCustomResponse);
      } else {
        BIS.create(bis_email, bis_variant_id, bis_product_id).then(
          BISCustomResponse
        );
      }
    }

    document
      .querySelector(".js-biscustom-submit")
      .addEventListener("click", BISCustomFormSubmit);
  }

  // Size Chart Modal
  if (document.querySelector(".js-size-chart-modal")) {
    const open_size_modal = document.querySelectorAll(".js-size-chart-open");
    const close_size_modal = document.querySelector(".js-size-chart-close");
    const overlay_size_modal = document.querySelector(".js-size-chart-overlay");
    const size_modal = document.querySelector(".js-size-chart-modal");
    var size_chart_focusable = size_modal.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    var focus_on_open;
    var focus_first_tab = true;

    // console.log(size_chart_focusable);

    let toggleSizeChart = function () {
      if (size_modal.classList.contains("hidden")) {
        focus_on_open = document.activeElement;
        document.addEventListener("keydown", trapFocus);

        window.requestAnimationFrame(() => {
          document.body.classList.add("size-chart-open");
          size_modal.classList.add("opacity-0");
          size_modal.classList.remove("hidden");

          window.requestAnimationFrame(() => {
            size_modal.classList.remove("opacity-0");
          });
        });
      } else {
        size_modal.addEventListener(
          "transitionend",
          () => {
            size_modal.classList.add("hidden");
          },
          { once: true }
        );
        document.removeEventListener("keydown", trapFocus);
        focus_first_tab = true;
        document.body.classList.remove("size-chart-open");

        if (focus_on_open) {
          focus_on_open.focus();
          focus_on_open = null;
        }

        window.requestAnimationFrame(() => {
          size_modal.classList.add("opacity-0");
        });
      }
    };

    let trapFocus = function (e) {
      var isTabPressed = e.key === "Tab";

      if (!isTabPressed) {
        return;
      }

      let first_focus = size_chart_focusable[0];
      let last_focus = size_chart_focusable[size_chart_focusable.length - 1];

      if (focus_first_tab) {
        first_focus.focus();
        e.preventDefault();
        focus_first_tab = false;
      } else {
        if (e.shiftKey) {
          /* shift + tab */ if (document.activeElement === first_focus) {
            last_focus.focus();
            e.preventDefault();
          }
        } /* tab */ else {
          if (document.activeElement === last_focus) {
            first_focus.focus();
            e.preventDefault();
          }
        }
      }
    };

    open_size_modal.forEach((e) => {
      e.addEventListener("click", toggleSizeChart);
    });
    close_size_modal.addEventListener("click", toggleSizeChart);
    overlay_size_modal.addEventListener("click", toggleSizeChart);
  }

  // Mobile PDP Sticky CTA
  if (is_desktop_size == false) {
    let stickUnstickCTA = function (entries) {
      entries.forEach((entry) => {
        let y_offset = window.scrollY + sentinel.getBoundingClientRect().top;

        // console.log(entry);
        // console.log('window.scrollY',window.scrollY);
        // console.log('y_offset',y_offset);
        // console.log('cta_height',cta_height);
        // console.log('sentinel', sentinel.getBoundingClientRect().top);

        if (entry.isIntersecting || window.scrollY >= y_offset) {
          // console.log('add');
          spacer.style.height = `${cta_height}px`;
          cta_container.classList.add("add-to-cart-container--sticky");
        } else if (window.scrollY <= y_offset) {
          // console.log('remove');
          cta_container.classList.remove("add-to-cart-container--sticky");
          spacer.style.height = "";
        }
      });
    };

    const sentinel = document.querySelector(".js-sticky-add-to-cart-observer");
    const cta_container = document.querySelector(".js-add-to-cart-container");
    let spacer = cta_container.parentElement;
    let cta_height = spacer.getBoundingClientRect().height;
    let sticky_observer_options = { root: null, rootMargin: "0px", threshold: 0 };
    const sticky_observer = new IntersectionObserver(
      stickUnstickCTA,
      sticky_observer_options
    );
    sticky_observer.observe(sentinel);
  }

  // Vimeo Product Video using metafields
  function setupModal(videoThumbnail, modal, modalClose) {
    if (videoThumbnail) {
      videoThumbnail.addEventListener("click", showModal);
    }
    // Show the modal
    function showModal() {
      modal.classList.remove("invisible");
      modal.classList.remove("opacity-0");
    }

    modalClose.addEventListener("click", closeVimeoModal);
    // Hide the modal
    function closeVimeoModal() {
      modal.classList.add("invisible");
      modal.classList.add("opacity-0");
    }
  }
  // Desktop product video
  const vimeoVideoThumbnail = document.getElementById("js-vimeoVideoThumbnail");
  const vimeoModal = document.getElementById("js-vimeoModal");
  const vimeoModalClose = document.getElementById("js-vimeoModalClose");
  setupModal(vimeoVideoThumbnail, vimeoModal, vimeoModalClose);

  // Mobile product video
  const vimeoVideoThumbnailMobile = document.getElementById(
    "js-vimeoVideoThumbnailMobile"
  );
  const vimeoModalMobile = document.getElementById("js-vimeoModalMobile");
  const vimeoModalCloseMobile = document.getElementById(
    "js-vimeoModalCloseMobile"
  );
  setupModal(vimeoVideoThumbnailMobile, vimeoModalMobile, vimeoModalCloseMobile);
  
}); // End Product Scripts
